<template>
	<div
		class="d-textarea"
		:class="{
			'dark-d': dark,
			error: error,
			disabled: disabled
		}"
	>
		<fieldset ref="fieldset">
			<legend :style="`width:${labelWidth}px`" ref="legend"><span></span></legend>
		</fieldset>
		<label ref="label" :class="{ filled: value.length != 0 || isFocused }">
			{{ label }}
		</label>
		<div class="d-textarea-inner">
			<textarea
				ref="textarea"
				:placeholder="placeholder"
				@input="($event) => updateValue($event.target.value, 'input')"
				@change="($event) => updateValue($event.target.value, 'change')"
				@keyup.enter="($event) => updateValue($event.target.value, 'change')"
				:value="value"
				:name="label"
				v-bind:disabled="disabled"
				rows="4"
			></textarea>
			<div v-if="isFocused && slider" class="textarea-slider">
				<!-- v-if="isFocused && min != null && max != null" -->
				<imdex-slider
					:labelOnChange="false"
					:rangeLabels="false"
					:value="value"
					:min="min"
					:max="max"
					@change="updateValue($event, 'change')"
				></imdex-slider>
			</div>
		</div>
		<div class="assistive-text">{{ assistive_text }}</div>
	</div>
</template>
<script>
export default {
	name: "imdex-textarea",
	data() {
		return {
			assistive_text: "",
			labelWidth: 0,
			labelInterval: null,
			isFocused: false
		};
	},
	props: {
		dark: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: "#3e80e3"
		},
		value: {
			type: String,
			default: ""
		},
		label: {
			type: String,
			default: ""
		},
		error: {
			type: Boolean,
			default: false
		},
		errorMessageText: {
			type: String,
			default: ""
		},
		slider: {
			type: Boolean,
			default: false
		},
		lazy: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	beforeUnmount() {
		clearInterval(this.labelInterval);
	},
	async mounted() {
		clearInterval(this.labelInterval);
		this.$nextTick(() => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					this.setLabelWidth();
				});
			});
			if (this.errorMessageText != "" && this.error) {
				this.assistive_text = this.errorMessageText;
			}
			if (this.$refs.textarea != null) {
				this.$refs.textarea &&
					this.$refs.textarea.addEventListener("focus", () => {
						this.isFocused = true;
					});
			}
			if (this.$refs.textarea != null) {
				this.$refs.textarea &&
					this.$refs.textarea.addEventListener("blur", () => {
						this.isFocused = false;
					});
			}
		});
	},
	watch: {
		isFocused() {
			this.setLabelWidth();
		},
		value() {
			this.$nextTick(this.setLabelWidth);
		}
	},
	methods: {
		updateValue(val, type = "input") {
			if (!this.lazy) {
				this.$emit("update:value", val);
				this.$emit("change", val);
			} else {
				if (type == "change") {
					this.$emit("update:value", val);
					this.$emit("change", val);
				}
			}
		},
		setLabelWidth() {
			this.$nextTick(() => {
				if (this.$refs.label != null) {
					if (this.label == null) return;
					this.labelInterval = setInterval(() => {
						// This interval is because there is a bug with vue that doesn't assign a width to the created ref right away.  This is the best solution to wait for an actual width value.
						if (this.$refs.label != null) {
							if (
								(this.$refs.label.scrollWidth > 0 && this.value.length != 0) ||
								this.isFocused
							) {
								this.labelWidth = Math.min(
									this.$refs.label.scrollWidth * 0.75 + 13,
									this.$el.offsetWidth - 24
								);
								clearInterval(this.labelInterval);
							}
							if (!this.isFocused && this.value.length == 0) {
								this.labelWidth = 0;
								clearInterval(this.labelInterval);
							}
						}
					}, 0);
				} else {
					this.labelWidth = 0;
				}
			});
		}
	}
};
</script>
<style scoped lang="scss">
textarea {
	outline: none;
	border: none;
	resize: none;
	font-family: inherit;
	&:focus {
		outline: none;
	}
}
.assistive-text {
	position: absolute;
	bottom: -16px;
	left: 20px;
	font-size: 12px;
	color: $imdex-text;
}
.d-textarea {
	.d-textarea-inner {
		display: flex;
		align-items: center;
	}
	text-align: left;
	&.a-right {
		textarea {
			text-align: right;
		}
	}
	position: relative;
	margin-top: 0px;
	flex: 1;
	background: transparent;
	border-radius: 5px;
	padding: 0;
	padding: 5px 10px;
	fieldset {
		border-collapse: collapse;
		border: 1px solid $imdex-borders;
		border-radius: inherit;
		bottom: 0;
		margin: 0;
		left: 0;
		pointer-events: none;
		position: absolute;
		right: 0;
		top: 0px;
		transition-duration: 0.15s;
		transition-property: color;
		transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
		legend {
			border: 0;
			width: 0;
			color: inherit;
			display: table;
			white-space: normal;
			max-width: 100%;
			line-height: 11px;
			padding: 0;
			transition: all 0.3s ease;
		}
	}

	textarea {
		color: #000;
		padding: 10px 10px;
		margin-right: -10px;
		font-size: 16px;
		width: 100%;
		&::-webkit-outer-spin-button {
			opacity: 0;
		}
		&::-webkit-inner-spin-button {
			opacity: 0;
		}
		&:focus {
			outline: none;
		}
	}
	&:focus-within {
		fieldset {
			border: solid 1px $imdex-highlight;

			legend {
				width: --label-width;
				transition: all 0.3s ease;
			}
		}
		label {
			color: $imdex-text;
			transform: translateY(-22px) translateX(-7px) scale(0.8, 0.8) !important;
		}
		.bottom-line {
			background: #000;
		}
	}
	.filled {
		color: $imdex-text;

		transform: translateY(-22px) translateX(-7px) scale(0.8, 0.8) !important;
	}
	label {
		transform-origin: top left;
		transition: all 0.3s ease;
		pointer-events: none;
		position: absolute;
		line-height: normal;
		left: 26px;
		top: 15px;
		overflow: hidden;
		padding: 0px;
		font-size: 12pt;
		white-space: nowrap;
		text-overflow: ellipsis;
		color: $imdex-dark-grey;
	}
	.textarea-slider {
		min-width: 130px;
		top: calc(100% - 4px);
		position: absolute;
		right: 0;
		background: #fff;
		padding: 20px 20px;
		border-radius: 4px;
		z-index: 1000;
		box-shadow: 0px 10px 22px -5px rgba(0, 0, 0, 0.8);
	}
	&.error {
		fieldset {
			border-color: $imdex-error !important;
		}
		label {
			color: $imdex-error !important;
		}
		textarea {
			color: $imdex-error !important;
		}
		.assistive-text {
			color: $imdex-error;
		}
	}
	&.disabled {
		fieldset {
			border-color: $imdex-tertiary-light !important;
			pointer-events: none;
		}
		label {
			color: $imdex-tertiary-light !important;
			pointer-events: none;
		}
		textarea {
			color: $imdex-tertiary-light !important;
			pointer-events: none;
		}
		.assistive-text {
			color: $imdex-tertiary-light !important;
			pointer-events: none;
		}
	}
	&.dark-d {
		fieldset {
			border: solid 1px #ffffff30;
		}
		label {
			color: rgba(#fff, 0.44);
			&.filled {
				color: #fff !important;
			}
		}
		textarea {
			color: #fff;
		}
		.bottom-line {
			background: transparent;
		}
		&:focus-within {
			fieldset {
				border: solid 1px #fff;
			}
			label {
				color: #fff;
				max-width: 153%;
				transform: translateY(-25px) translateX(0px) scale(0.7, 0.7);
			}
			.bottom-line {
				background: transparent;
			}
		}
	}
}
</style>
